var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c("div", { staticClass: "col-sm-12 col-xs-12 team-wrapper" }, [
        _vm._m(1),
        _c("div", { staticClass: "col-sm-6 col-sm-pull-6 col-xs-12" }, [
          _c("div", { staticClass: "row mr-bt-5p" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
              [_vm._v("First Name")]
            ),
            _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.team.first_name,
                    expression: "team.first_name",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "First Name",
                  maxlength: "35",
                },
                domProps: { value: _vm.team.first_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.team, "first_name", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "row mr-bt-5p" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
              [_vm._v("Last Name")]
            ),
            _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.team.last_name,
                    expression: "team.last_name",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Last Name",
                  maxlength: "35",
                },
                domProps: { value: _vm.team.last_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.team, "last_name", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "row",
              class:
                _vm.displayEmailErrorMsg || _vm.addMemberError
                  ? "mr-bt-0p"
                  : "mr-bt-5p",
            },
            [
              _c(
                "div",
                { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
                [_vm._v("Email")]
              ),
              _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.team.email,
                      expression: "team.email",
                    },
                  ],
                  staticClass: "form-control",
                  class:
                    _vm.displayEmailErrorMsg || _vm.addMemberError
                      ? "invalid-border"
                      : "",
                  attrs: {
                    type: "text",
                    placeholder: "Email",
                    maxlength: "65",
                  },
                  domProps: { value: _vm.team.email },
                  on: {
                    blur: _vm.emailVal,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.team, "email", $event.target.value)
                    },
                  },
                }),
                _vm.addMemberError
                  ? _c(
                      "div",
                      {
                        staticClass: "validation-message",
                        staticStyle: {
                          "padding-left": "2px",
                          "font-size": "14px",
                          float: "left",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.addMemberError) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.displayEmailErrorMsg,
                        expression: "displayEmailErrorMsg",
                      },
                    ],
                    staticClass: "custom-error-class",
                  },
                  [_c("span", [_vm._v("Invalid email.")])]
                ),
              ]),
            ]
          ),
          _vm.multi_factor_key
            ? _c(
                "div",
                {
                  staticClass: "row",
                  class: _vm.displayIpErrorMsg ? "mr-bt-0p" : "mr-bt-5p",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
                    [_vm._v("IP Address")]
                  ),
                  _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.team.ip_address,
                          expression: "team.ip_address",
                        },
                      ],
                      staticClass: "form-control",
                      class: _vm.displayIpErrorMsg ? "invalid-border" : "",
                      attrs: {
                        type: "text",
                        placeholder: "IP Address (xxx.xxx.xxx.xxx)",
                      },
                      domProps: { value: _vm.team.ip_address },
                      on: {
                        blur: _vm.ipAddressVal,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.team, "ip_address", $event.target.value)
                        },
                      },
                    }),
                    _vm.displayIpErrorMsg
                      ? _c("div", { staticClass: "custom-error-class" }, [
                          _c("span", [_vm._v("Invalid IP Address.")]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "row mr-bt-5p" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
              [_vm._v("Role")]
            ),
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-10 custom-dropdown" },
              [
                _c("multiselect", {
                  staticClass: "multiselect-single-dropdown",
                  class: !_vm.team.role ? "un-selected" : "",
                  attrs: {
                    showLabels: false,
                    "close-on-select": true,
                    "allow-empty": false,
                    searchable: false,
                    options: _vm.roles.map((role) => role.id),
                    "custom-label": _vm.getRoleNameById,
                    placeholder: "Select Role",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.getRoleBasedTemplate(_vm.team.role)
                    },
                  },
                  model: {
                    value: _vm.team.role,
                    callback: function ($$v) {
                      _vm.$set(_vm.team, "role", $$v)
                    },
                    expression: "team.role",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.team.role == "6"
            ? _c("div", { staticClass: "row mr-bt-5p" }, [
                _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
                  _vm._v("Distributor"),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-sm-12 col-xs-12 col-md-10 custom-dropdown",
                  },
                  [
                    _c("multiselect", {
                      staticClass: "multiselect-single-dropdown",
                      attrs: {
                        disabled: _vm.team.role != "6",
                        showLabels: false,
                        "close-on-select": true,
                        "allow-empty": false,
                        searchable: false,
                        options: _vm.localDistributors.map(
                          (distributor) => distributor.id
                        ),
                        "custom-label": (option) =>
                          _vm.localDistributors.find((x) => x.id === option)
                            .distributor_name,
                        placeholder: "Select distributor",
                      },
                      model: {
                        value: _vm.team.assigned_distributor_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.team, "assigned_distributor_id", $$v)
                        },
                        expression: "team.assigned_distributor_id",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm.userServiceList.length
          ? _c(
              "div",
              { staticClass: "col-md-12 col-sm-12 col-xs-12 pb-20" },
              [
                _vm._m(2),
                _vm._l(_vm.userServiceList, function (service, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "col-md-12 col-sm-12 col-xs-12 bt-border",
                    },
                    [
                      service.key != "REPRESENTATION_RESOURCES" ||
                      _vm.account_type_id != 3
                        ? _c("div", { staticClass: "row pb-8 pt-8" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-7 col-xs-8 d-flex align-items-center",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "checkbox mr-12",
                                    class: {
                                      "link-disabled":
                                        !_vm.disablePermissionCheck(service.id),
                                    },
                                  },
                                  [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: service.access,
                                            expression: "service.access",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "checkbox",
                                          disabled: !_vm.disablePermissionCheck(
                                            service.id
                                          ),
                                        },
                                        domProps: {
                                          checked: Array.isArray(service.access)
                                            ? _vm._i(service.access, null) > -1
                                            : service.access,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a = service.access,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      service,
                                                      "access",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      service,
                                                      "access",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(service, "access", $$c)
                                              }
                                            },
                                            function ($event) {
                                              return _vm.revertOldPermissions(
                                                service.id,
                                                service.access
                                              )
                                            },
                                          ],
                                        },
                                      }),
                                      _c("span", { staticClass: "cr" }),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "cust_label",
                                    class: {
                                      "link-disabled":
                                        !_vm.disablePermissionCheck(service.id),
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(service.name) + " ")]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "col-sm-3 col-xs-4" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "edit-lnk",
                                  class: {
                                    "link-disabled":
                                      !_vm.disablePermissionCheck(service.id) ||
                                      !service.access,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.disablePermissionCheck(service.id) &&
                                      service.access
                                        ? _vm.openPermissionsPopup(service)
                                        : null
                                    },
                                  },
                                },
                                [_vm._v(" edit ")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass:
            "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-block emergo-white-button",
                  attrs: { type: "button" },
                  on: { click: _vm.cancelAddTeam },
                },
                [_vm._v(" Cancel ")]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-block emergo-green-button",
                  attrs: {
                    type: "button",
                    disabled: _vm.disableButtonForAddTeam || _vm.loaderStatus,
                  },
                  on: { click: _vm.addTeamMember },
                },
                [_vm._v(" Save/Add ")]
              ),
            ]
          ),
        ]
      ),
      _c("member-permissions", {
        attrs: {
          memberName: _vm.memberName,
          serviceId: _vm.serviceId,
          userServiceList: _vm.userServiceList,
          rolesServicesList: _vm.servicesList,
        },
        on: { updateUserPermission: _vm.updateUserPermission },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("hr"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 col-sm-6 col-sm-push-6" }, [
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-10",
          staticStyle: { "padding-top": "10px", "text-align": "center" },
        },
        [
          _c("img", {
            staticClass: "new_member_img",
            attrs: {
              src: "/static/images/icons/blank_image.svg",
              alt: "blank-icon",
            },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-xs-12 bt-border" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-7 col-xs-6" }, [
            _vm._v("Services access"),
          ]),
          _c("div", { staticClass: "col-sm-3 col-xs-6 txt-alg-rt" }, [
            _vm._v("Permissions"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }